import { Routes } from "@angular/router";

export const PurchasesRoutes: Routes = [
	{
		path: "",
		loadComponent: () =>
			import('@/app/domains/erp/purchases/pages/branch-purchases/branch-purchases.page').then(
				(m) => m.BranchPurchasesPage
			),
	},
	{
		path: "purchase-view",
		loadComponent: () =>
			import('@/app/domains/erp/purchases/pages/purchase-view/purchase-view.page').then(
				(m) => m.PurchaseViewPage
			),
	},
	{
		path: "**",
		redirectTo: "",
		pathMatch: "full",
	},
];
